import { Icon, Text } from "@src/straps/base";
import { useIsLeftNavCollapsed } from "@src/straps/base/navigation/LeftNav/state";
import classNames from "classnames";
import { Link } from "react-router-dom";

export function RebatesItem() {
  const isLeftNavCollapsed = useIsLeftNavCollapsed();

  return (
    <Link
      className="relative flex h-16 cursor-pointer bg-straps-warning-hover px-6 py-4 hover:bg-straps-warning"
      to="/rebates"
    >
      <div
        className={classNames("absolute left-7 top-6 transition-opacity", {
          "opacity-0": !isLeftNavCollapsed,
          "opacity-100": isLeftNavCollapsed,
        })}
      >
        <Icon name="rebates" size="small" color="primary" />
      </div>
      <div
        className={classNames(
          "flex shrink-0 flex-nowrap items-center gap-3 overflow-hidden transition-opacity",
          {
            "opacity-0": isLeftNavCollapsed,
            "opacity-100": !isLeftNavCollapsed,
          }
        )}
      >
        <Icon name="rebates" size="extraLarge" color="primary" />
        <div>
          <Text variant="sa_t-14-700">Backpack Rebates</Text>
          <Text variant="sb_t-10-500">Get cash back</Text>
        </div>
      </div>
    </Link>
  );
}
